import React, { useState, useEffect } from "react";
import { Card, Form, Alert } from "react-bootstrap";
import { FormPreview } from "./FormPreview";
import { IoWarningOutline } from "react-icons/io5";
import { IoMdClose } from "react-icons/io";
import FormCreator from "./FormCreator";
import {
  FaEdit,
  FaTrash,
  FaEye,
  FaCopy,
  FaArrowLeft,
  FaCalendarAlt,
  FaPlus,
  FaUserCheck,
  
} from 'react-icons/fa'
import { Link } from "react-router-dom";
import {
  EditForm,
  CreateFormes,
  GetFormes,
  UpdateFormes,
} from "../../../api/Webservices";
import { useUser } from '../../AdminUsers/UserContext';
import { showToast, ToastMessage } from "../../Shared/ToastMessage";


const generateId = () =>
  `form_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

const EventID = localStorage.getItem("eventId") || "";

const FormsDashboard = () => {
  const { checkPermission } = useUser()
  // State for forms list
  const [forms, setForms] = useState([])
  const [currentView, setCurrentView] = useState('list')
  const [currentFormId, setCurrentFormId] = useState(null)
  const [isEditMode, setIsEditMode] = useState(false)
  const [newFormIsMembership, setNewFormIsMembership] = useState(false) // New: tracks AMASI toggle in modal
  // Modal states
  const [showNewFormModal, setShowNewFormModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [formToDelete, setFormToDelete] = useState(null)
  const [newFormName, setNewFormName] = useState('')
  const [newFormDescription, setNewFormDescription] = useState('')

  const FormTypes = [
    {
      id: 1,
      name: 'Attendee',
      description: 'Attendee registration form for events',
    },
    {
      id: 2,
      name: 'Guest',
      description: 'Guest registration form for events',
    },
    {
      id: 3,
      name: 'Buyer',
      description: 'Buyer registration form for events',
    },
   
  ]

  const [NewFormType, setNewFormType] = useState(FormTypes)
  const [selectedFormType, setSelectedFormType] = useState(
    isEditMode ? '' : 'Attendee'
  )
  // New: Helper to add AMASI field if toggled
  const addAmasiFieldToNewForm = (fields, isMembership) => {
    if (!isMembership) return fields
    const amasiField = {
      id: `field-${Date.now()}-amasimembership`,
      type: 'text',
      label: 'AMASI Membership Reg.email',
      name: 'amasimembership_number',
      placeholder: 'Enter your registered  email or phone number.',
      required: true,
      helpText: '',
      isDefault: true, // Non-deletable
    }
    // Add if not present
    if (!fields.some((f) => f.name === 'amasimembership_number')) {
      return [...fields, amasiField]
    }
    return fields
  }
  const handleCreateFormopen = async () => {
    const hasPermission = await checkPermission('Dynamic Forms', 'create')
    if (!hasPermission) return
    setShowNewFormModal(true)
  }
// ── Helper: move AMASI membership field to the very first position ──
const moveMembershipFieldToTop = (fields = []) => {
  const membershipField = fields.find(f => f.name === "amasimembership_number");
  if (!membershipField) return fields;            

  const withoutMembership = fields.filter(f => f.name !== "amasimembership_number");

  // Put it at index 0
  return [membershipField, ...withoutMembership];
};
  useEffect(() => {
    const GetData = {
      status: 'active',
      event_id: EventID,
    }

    GetFormes(GetData)
      .then((res) => {
        if (!res || !res.data) {
          console.error('API returned invalid response structure:', res)
          return
        }

        let formsArray = res.data.forms
        if (!Array.isArray(formsArray)) {
          console.warn(
            'API response.data.forms is not an array, converting to array.'
          )
          formsArray = [formsArray]
        }

        try {
          const processedForms = formsArray.map((formData) => {
            // Parse the fields JSON string
            let parsedFields = []
            // IMPORTANT: Use 'fileds' (with typo) from API response
            if (formData.fileds) {
              try {
                let fieldsString = formData.fileds

                // Remove outer quotes if they exist
                if (
                  typeof fieldsString === 'string' &&
                  fieldsString.startsWith('"') &&
                  fieldsString.endsWith('"')
                ) {
                  fieldsString = fieldsString.slice(1, -1)
                }

                // Unescape the inner JSON string
                fieldsString = fieldsString
                  .replace(/\\"/g, '"')
                  .replace(/\\\\/g, '\\')
                  .replace(/\\n/g, '\n')
                  .replace(/\\r/g, '\r')
                  .replace(/\\t/g, '\t')

                // Parse the JSON array
                parsedFields = JSON.parse(fieldsString)
              } catch (parseError) {
                console.error(
                  'Error parsing fields for form',
                  formData.id,
                  ':',
                  parseError
                )

                parsedFields = []
              }
            } else {
            }

            const processedForm = {
              event_id: EventID,
              form_type: formData.form_type || selectedFormType,
              id: formData.id,
              form_id: formData.form_id,
              form_title: formData.form_title,
              form_description: formData.form_description,
              fields: parsedFields,
              member_form: formData.member_form || false,
              createdAt: formData.created_at,
              updatedAt: formData.created_at,
              submissions: 0,
            }

            return processedForm
          })
          console.log('Processed Forms:', processedForms)
          setForms(processedForms)
        } catch (e) {
          console.error('Error in form processing:', e)
        }
      })
      .catch((error) => {
        console.error('Error fetching forms:', error)
      })
  }, [])

  // Create a new form
  // Create a new form
  const createNewForm = () => {
    if (!newFormName.trim()) {
      showToast('Form Name is required.', 'error')
      return
    }

    // New: Start with default fields (matching FormCreator)
    let defaultFields = [
      {
        id: `field-${Date.now()}-firstname`,
        type: 'text',
        label: 'First Name',
        name: 'first_name',
        placeholder: 'Enter your first name',
        required: true,
        helpText: '',
        isDefault: true,
      },
      {
        id: `field-${Date.now() + 1}-lastname`,
        type: 'text',
        name: 'last_name',
        label: 'Last Name',
        placeholder: 'Enter your last name',
        required: true,
        helpText: '',
        isDefault: true,
      },
      {
        id: `field-${Date.now() + 2}-email`,
        type: 'email',
        name: 'email_address',
        label: 'Email Address',
        placeholder: 'Enter your email address',
        required: true,
        helpText: '',
        isDefault: true,
      },
        {
    id: `field-${Date.now() + 3}-phone`,
    type: 'tel',
    name: 'phone_number',
    label: 'Phone Number',
    placeholder: 'Enter your phone number',
    required: true,
    helpText: '',
    isDefault: true,
  },
    ]

    // New: Add AMASI field if toggled
    defaultFields = addAmasiFieldToNewForm(defaultFields, newFormIsMembership)
defaultFields = moveMembershipFieldToTop(defaultFields);
    const newForm = {
      id: generateId(),
      form_id: generateId(),
      form_title: newFormName,
      form_description: newFormDescription,
      form_type: selectedFormType,
      fields: defaultFields, // New: Include defaults + AMASI if toggled
      member_form: newFormIsMembership, // New: Save flag
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      submissions: 0,
    }

    setForms([...forms, newForm])
    setNewFormName('')
    setNewFormDescription('')
    setNewFormIsMembership(false) // New: Reset toggle
    setShowNewFormModal(false)

    // Automatically open the new form for editing
    setCurrentFormId(newForm.id)
    setCurrentView('create')
    setIsEditMode(false)
  }

  // Delete a form
  const deleteForm = () => {
    if (!formToDelete) return

    // Find the form to delete
    const formData = forms.find((form) => form.id === formToDelete)
    if (!formData) {
      console.error('Form not found for deletion')
      return
    }

    // Prepare the data for the API call
    const deleteFormData = {
      event_id: EventID,
      form_type: selectedFormType,
      id: formData.id,
      form_id: formData.form_id || formData.id,
      form_title: formData.form_title,
      form_description: formData.form_description,
      fileds: JSON.stringify(formData.fields || []),
      status: 'deleted', // Set status to deleted
    }

    // Call the UpdateFormes API to mark the form as deleted
    UpdateFormes(deleteFormData)
      .then((res) => {
        if (res && res.data && res.data.success === true) {
          // Update the local state to reflect the deletion
          setForms(forms.filter((form) => form.id !== formToDelete))
          showToast('Form deleted successfully!', 'success')
        } else {
          console.error('API returned error for deletion:', res)
          showToast('Failed to delete form. Please try again.', 'error')
        }
      })
      .catch((error) => {
        console.error('Error deleting form:', error)
        showToast('Failed to delete form. Please try again.', 'error')
      })
      .finally(() => {
        // Clean up
        setShowDeleteModal(false)
        setFormToDelete(null)
        if (currentFormId === formToDelete) {
          setCurrentView('list')
          setCurrentFormId(null)
        }
      })
  }

  // Duplicate a form
  const duplicateForm = (formId) => {
    const formToDuplicate = forms.find((form) => form.id === formId)
    if (!formToDuplicate) return

    const duplicatedForm = {
      ...formToDuplicate,
      id: generateId(),
      form_title: `${formToDuplicate.form_title} (Copy)`,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      submissions: 0,
    }

    setForms([...forms, duplicatedForm])
  }

  // Update a form
  const updateForm = (formId, updatedFormData) => {
    setForms(
      forms.map((form) => {
        if (form.id === formId) {
          return {
            ...form,
            ...updatedFormData,
            fields: updatedFormData.fields || form.fields || [],
            updatedAt: new Date().toISOString(),
          }
        }
        return form
      })
    )
  }

  // Handle form save from FormCreator
  const handleFormSave = (formData) => {
    if (!currentFormId) {
      console.error('No current form ID')
      return
    }

    const currentForm = forms.find((form) => form.id === currentFormId)
    if (!currentForm) {
      console.error('Current form not found')
      return
    }

    // Prepare the complete form data
    const completeFormData = {
      event_id: EventID,
      form_type: selectedFormType,
      id: forms.id,
      ...formData,
      form_id: currentForm.form_id || currentForm.id,
      status: 'active',
      fileds: JSON.stringify(formData.fields || []),
      member_form: formData.member_form || false,
    }

    // Choose the correct API function
    const saveFunction = isEditMode ? UpdateFormes : CreateFormes

    // Call the API
    saveFunction(completeFormData)
      .then((res) => {
        if (res && res.data.success === true) {
          // Update the local forms state
          updateForm(currentFormId, {
            ...formData,
            fields: formData.fields || [],
          })
          window.location.reload()
          showToast(
            isEditMode
              ? 'Form updated successfully!'
              : 'Form created successfully!',
            'success'
          )
          // Navigate back to list view
          setCurrentView('list')
          setCurrentFormId(null)
          setIsEditMode(false)
        } else {
          console.error('API returned error:', res)
          alert('Error saving form. Please try again.')
        }
      })
      .catch((error) => {
        console.error('Error saving form:', error)
        showToast(
          isEditMode ? 'Form updated Failed!' : 'Form created Failed!',
          'error'
        )
      })
  }

  // JSX Methods for modern design
  const renderHeader = () => (
    // <div
    //   style={{
    //     background: "white",
    //     borderRadius: "12px",
    //     padding: "2rem",
    //     marginBottom: "2rem",
    //     boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    //     border: "1px solid #e5e7eb",
    //   }}
    // >
    //   <div
    //     style={{
    //       display: "flex",
    //       justifyContent: "space-between",
    //       alignItems: "center",
    //     }}
    //   >
    //     <div>
    //       <h1
    //         style={{
    //           fontSize: "2rem",
    //           fontWeight: "700",
    //           marginBottom: "0.5rem",
    //           color: "#1f2937",
    //         }}
    //       >
    //         Dynamic Forms
    //       </h1>
    //       {/* <nav aria-label="breadcrumb">
    //         <ol
    //           style={{
    //             display: "flex",
    //             listStyle: "none",
    //             padding: 0,
    //             margin: 0,
    //             fontSize: "0.875rem",
    //             color: "#6b7280",
    //           }}
    //         >
    //           <li style={{ marginRight: "0.5rem" }}>
    //             <Link
    //               to="/events/admin/"
    //               style={{ color: "#6b7280", textDecoration: "none" }}
    //             >
    //               AMASI
    //             </Link>
    //           </li>
    //           <li style={{ marginRight: "0.5rem" }}>/</li>
    //           <li>Dynamic Forms</li>
    //         </ol>
    //       </nav> */}
    //     </div>
    //     <button
    //       onClick={() => handleCreateFormopen()}
    //       style={{
    //         background: "#184778",
    //         border: "none",
    //         borderRadius: "8px",
    //         padding: "12px 24px",
    //         color: "white",
    //         fontSize: "0.875rem",
    //         fontWeight: "600",
    //         cursor: "pointer",
    //         transition: "all 0.2s ease",
    //         display: "flex",
    //         alignItems: "center",
    //         gap: "8px",
    //       }}
    //       onMouseOver={(e) => {
    //         e.target.style.background = "#0f3a5f";
    //         e.target.style.transform = "translateY(-1px)";
    //       }}
    //       onMouseOut={(e) => {
    //         e.target.style.background = "#184778";
    //         e.target.style.transform = "translateY(0)";
    //       }}
    //     >
    //       <FaPlus size={14} />
    //       Create New Form
    //     </button>
    //   </div>
    // </div>

    <div style={{ marginBottom: '22px' }}>
      <div className="brood_comes_div">
        <div className="row align-items-center">
          <div className="col-md-6 brood_comes_heading">
            <h2>
              <div className="brood_comes_part">
                {/* <FaCheck /> */}
                <i class="fa fa-credit-card"></i>
              </div>
              Dynamic Forms
            </h2>
          </div>
          <div className="col-md-6 text-end">
            <button
              onClick={() => handleCreateFormopen()}
              className="btn btn-outline-primary "
            >
              <FaPlus size={14} />
              Create New Form
            </button>
          </div>
        </div>
      </div>
    </div>
  )

  const renderEmptyState = () => (
    <div
      style={{
        background: 'white',
        borderRadius: '12px',
        padding: '4rem 2rem',
        textAlign: 'center',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #e5e7eb',
      }}
    >
      <div>
        <div
          style={{
            width: '80px',
            height: '80px',
            background: '#f3f4f6',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 2rem',
          }}
        >
          <FaCalendarAlt size={32} color="#6b7280" />
        </div>

        <h2
          style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '1rem',
          }}
        >
          No Forms Created Yet
        </h2>

        <p
          style={{
            fontSize: '1rem',
            color: '#6b7280',
            marginBottom: '2rem',
            maxWidth: '500px',
            margin: '0 auto 2rem',
          }}
        >
          Create your first event form to start collecting registrations and
          managing attendees.
        </p>

        <button
          onClick={() => setShowNewFormModal(true)}
          style={{
            background: '#184778',
            border: 'none',
            borderRadius: '8px',
            padding: '12px 24px',
            color: 'white',
            fontSize: '0.875rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
          }}
          onMouseOver={(e) => {
            e.target.style.background = '#0f3a5f'
            e.target.style.transform = 'translateY(-1px)'
          }}
          onMouseOut={(e) => {
            e.target.style.background = '#184778'
            e.target.style.transform = 'translateY(0)'
          }}
        >
          <FaPlus size={14} />
          Create New Form
        </button>
      </div>
    </div>
  )

  const renderFormsTable = () => (
    <div
      style={{
        background: 'white',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid #e5e7eb',
      }}
    >
      <div
        style={{
          background: '#f9fafb',
          padding: '15px 24px',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: '20px',

            color: '#1f2937',
          }}
        >
          Your Forms
        </h3>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f9fafb' }}>
              <th style={tableHeaderStyle}>Form Name</th>
              <th style={tableHeaderStyle}>Description</th>
              <th style={tableHeaderStyle}>Last Updated</th>
              <th style={{ ...tableHeaderStyle, textAlign: 'center' }}>
                Fields
              </th>
              {/* <th style={{ ...tableHeaderStyle, textAlign: "center" }}>
                Submissions
              </th> */}
              <th style={{ ...tableHeaderStyle, textAlign: 'right' }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {forms.map((form, index) => (
              <tr
                key={form.id}
                style={{
                  borderBottom: '1px solid #f3f4f6',
                  transition: 'all 0.2s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = '#f9fafb'
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = 'white'
                }}
              >
                <td style={tableCellStyle}>
                  <div style={{ fontWeight: '600', color: '#1f2937' }}>
                    {form.form_title}
                  </div>
                </td>
                <td style={tableCellStyle}>
                  <div style={{ color: '#6b7280' }}>
                    {form.form_description ? form.form_description : '--'}
                  </div>
                </td>
                <td style={tableCellStyle}>
                  <div style={{ color: '#6b7280' }}>
                    {form.createdAt
                      ? new Date(form.createdAt).toLocaleDateString()
                      : 'N/A'}
                  </div>
                </td>
                <td style={{ ...tableCellStyle, textAlign: 'center' }}>
                  <span
                    style={{
                      background: '#dbeafe',
                      color: '#1e40af',
                      padding: '4px 12px',
                      borderRadius: '16px',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                    }}
                  >
                    {form.fields?.length || 0}
                  </span>
                </td>
                {/* <td style={{ ...tableCellStyle, textAlign: "center" }}>
                  <span
                    style={{
                      background: "#fef3c7",
                      color: "#92400e",
                      padding: "4px 12px",
                      borderRadius: "16px",
                      fontSize: "0.75rem",
                      fontWeight: "600",
                    }}
                  >
                    {form.submissions || 0}
                  </span>
                </td> */}
                <td style={{ ...tableCellStyle, textAlign: 'right' }}>
                  <div
                    style={{
                      display: 'flex',
                      gap: '8px',
                      justifyContent: 'flex-end',
                    }}
                  >
                    {renderActionButton(
                      async () => {
                        const hasPermission = await checkPermission(
                          'Dynamic Forms',
                          'update'
                        )
                        if (!hasPermission) return
                        setCurrentFormId(form.id)
                        setCurrentView('create')
                        setIsEditMode(true)
                      },
                      <FaEdit size={14} />,
                      '#184778'
                    )}
                    {renderActionButton(
                      () => {
                        setCurrentFormId(form.id)
                        setCurrentView('preview')
                      },
                      <FaEye size={14} />,
                      '#059669'
                    )}
                    {renderActionButton(
                      async () => {
                        const hasPermission = await checkPermission(
                          'Dynamic Forms',
                          'delete'
                        )
                        if (!hasPermission) return
                        setFormToDelete(form.id)
                        setShowDeleteModal(true)
                      },
                      <FaTrash size={14} />,
                      '#dc2626'
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )

  const renderActionButton = (onClick, icon, color) => (
    <button
      onClick={onClick}
      style={{
        width: '32px',
        height: '32px',
        borderRadius: '6px',
        border: 'none',
        background: color,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
      onMouseOver={(e) => {
        e.target.style.transform = 'translateY(-1px)'
        e.target.style.opacity = '0.9'
      }}
      onMouseOut={(e) => {
        e.target.style.transform = 'translateY(0)'
        e.target.style.opacity = '1'
      }}
    >
      {icon}
    </button>
  )

  const renderNewFormModal = () => (
    <div
      style={{
        position: 'fixed',
        top: 0,
        right: showNewFormModal ? 0 : '-500px',
        width: '500px',
        height: '100vh',
        background: 'white',
        boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.15)',
        transition: 'right 0.3s ease',
        zIndex: 1050,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          background: '#184778',
          padding: '2rem',
          color: 'white',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600' }}>
            Create New Form
          </h3>
          <button
            onClick={() => setShowNewFormModal(false)}
            style={{
              background: 'rgba(255, 255, 255, 0.2)',
              border: 'none',
              borderRadius: '6px',
              width: '32px',
              height: '32px',
              color: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.3)'
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.2)'
            }}
          >
            <IoMdClose size={18} />
          </button>
        </div>
      </div>

      <div style={{ padding: '2rem', flex: 1 }}>
        <Form>
          <Form.Group style={{ marginBottom: '1.5rem' }}>
            <Form.Label
              style={{
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '0.5rem',
              }}
            >
              Form Name <span style={{ color: '#dc3545' }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter form name"
              value={newFormName}
              onChange={(e) => setNewFormName(e.target.value)}
              style={{
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                padding: '12px',
                fontSize: '0.875rem',
                transition: 'all 0.2s ease',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#184778'
                e.target.style.boxShadow = '0 0 0 3px rgba(24, 71, 120, 0.1)'
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#d1d5db'
                e.target.style.boxShadow = 'none'
              }}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: '2rem' }}>
            <Form.Label
              style={{
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '0.5rem',
              }}
            >
              Form Type
            </Form.Label>
            <Form.Control
              as="select"
              value={selectedFormType}
              onChange={(e) => {
                const selectedName = e.target.value
                setSelectedFormType(selectedName)

                // const selectedForm = NewFormType.find(
                //   (form) => form.name === selectedName
                // );
                // setNewFormDescription(selectedForm ? selectedForm.description : "");
              }}
              style={{
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                padding: '2px',
                fontSize: '0.876rem',
                transition: 'all 0.2s ease',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#184778'
                e.target.style.boxShadow = '0 0 0 3px rgba(24, 71, 120, 0.1)'
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#d1d5db'
                e.target.style.boxShadow = 'none'
              }}
            >
              <option value="">Select a form type</option>
              {NewFormType.map((form) => (
                <option key={form.id} value={form.name}>
                  {form.name}
                </option>
              ))}
            </Form.Control>
            {selectedFormType === "Attendee" &&
            <Form.Group >
              <Form.Check
                type="checkbox"
                id="new-form-membership"
                label={
                  <span>
                    <FaUserCheck
                      style={{ marginRight: '0.5rem', color: '#184778' }}
                    />
                    AMASI Member Form
                  </span>
                }
                checked={newFormIsMembership}
                onChange={(e) => setNewFormIsMembership(e.target.checked)}
              />
              <Form.Text className="text-muted">
                If this is an AMASI member form (adds default membership number
                field)
              </Form.Text>
            </Form.Group>
            }
            {/* {newFormDescription && (
              <div
                style={{
                  marginTop: "0.5rem",
                  fontSize: "0.85rem",
                  color: "#555",
                }}
              >
                {newFormDescription}
              </div>
            )} */}
          </Form.Group>

          <Form.Group style={{ marginBottom: '2rem' }}>
            <Form.Label
              style={{
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '0.5rem',
              }}
            >
              Form Description
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Enter form description"
              value={newFormDescription}
              onChange={(e) => setNewFormDescription(e.target.value)}
              style={{
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                padding: '12px',
                fontSize: '0.875rem',
                transition: 'all 0.2s ease',
                resize: 'vertical',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#184778'
                e.target.style.boxShadow = '0 0 0 3px rgba(24, 71, 120, 0.1)'
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#d1d5db'
                e.target.style.boxShadow = 'none'
              }}
            />
          </Form.Group>
        </Form>

        <div
          style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}
        >
          <button
            onClick={() => setShowNewFormModal(false)}
            style={{
              background: '#f9fafb',
              border: '1px solid #d1d5db',
              borderRadius: '6px',
              padding: '10px 20px',
              color: '#374151',
              fontSize: '0.875rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#f3f4f6'
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#f9fafb'
            }}
          >
            Cancel
          </button>
          <button
            onClick={createNewForm}
            // disabled={!newFormName.trim()}
            style={{
              background: '#184778',
              border: 'none',
              borderRadius: '6px',
              padding: '10px 20px',
              color: 'white',
              fontSize: '0.875rem',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              if (newFormName.trim()) {
                e.target.style.background = '#0f3a5f'
              }
            }}
            onMouseOut={(e) => {
              if (newFormName.trim()) {
                e.target.style.background = '#184778'
              }
            }}
          >
            Create Form
          </button>
        </div>
      </div>
    </div>
  )

  const renderDeleteModal = () =>
    showDeleteModal && (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1060,
        }}
      >
        <div
          style={{
            background: 'white',
            borderRadius: '12px',
            padding: '2rem',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            position: 'relative',
          }}
        >
          <button
            onClick={() => setShowDeleteModal(false)}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              background: '#f9fafb',
              border: 'none',
              borderRadius: '6px',
              width: '32px',
              height: '32px',
              color: '#6b7280',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.2s ease',
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#f3f4f6'
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#f9fafb'
            }}
          >
            <IoMdClose size={16} />
          </button>

          <div style={{ textAlign: 'center' }}>
            <div
              style={{
                width: '60px',
                height: '60px',
                background: '#fef2f2',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
              }}
            >
              <IoWarningOutline size={28} color="#dc2626" />
            </div>

            <h4
              style={{
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '1rem',
              }}
            >
              Delete Form
            </h4>

            <p
              style={{
                color: '#6b7280',
                marginBottom: '2rem',
                lineHeight: '1.5',
              }}
            >
              Are you sure you want to delete this form? This action cannot be
              undone.
            </p>

            <div
              style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}
            >
              <button
                onClick={() => setShowDeleteModal(false)}
                style={{
                  background: '#f9fafb',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  padding: '10px 20px',
                  color: '#374151',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.background = '#f3f4f6'
                }}
                onMouseOut={(e) => {
                  e.target.style.background = '#f9fafb'
                }}
              >
                Cancel
              </button>
              <button
                onClick={deleteForm}
                style={{
                  background: '#dc2626',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '10px 20px',
                  color: 'white',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.background = '#b91c1c'
                }}
                onMouseOut={(e) => {
                  e.target.style.background = '#dc2626'
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    )

  // Render the forms list
  const renderFormsList = () => (
    <div
      style={{
        minHeight: '100vh',
        background: '#f9fafb',
        padding: '24px 15px',
      }}
    >
      <ToastMessage />
      {checkUserLoading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '500px' }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div style={{}}>
          {renderHeader()}

          {forms.length === 0 ? renderEmptyState() : renderFormsTable()}

          {renderNewFormModal()}
          {renderDeleteModal()}
        </div>
      )}
    </div>
  )

  // Form Preview Page Component
  const FormPreviewPage = ({ formId, forms, onBack }) => {
    const [submitted, setSubmitted] = useState(false)
    const currentForm = forms.find((form) => form.id === formId)

    if (!currentForm) {
      return <div>Form not found</div>
    }
    const handleSubmit = (formValues) => {
      console.log('Form Submission:', {
        formId: currentForm.id,
        formTitle: currentForm.form_title,
        submittedAt: new Date().toISOString(),
        values: formValues,
      })

      updateForm(formId, {
        submissions: (currentForm.submissions || 0) + 1,
      })

      setSubmitted(true)
    }
    if (submitted) {
      return (
        <div
          style={{
            minHeight: '100vh',
            background: '#f9fafb',
            padding: '24px 15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              background: 'white',
              borderRadius: '12px',
              padding: '3rem',
              textAlign: 'center',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
              border: '1px solid #e5e7eb',
              maxWidth: '500px',
            }}
          >
            <div
              style={{
                width: '60px',
                height: '60px',
                background: '#dcfce7',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1.5rem',
              }}
            >
              <span style={{ fontSize: '24px' }}>✓</span>
            </div>
            <h4
              style={{
                fontSize: '1.5rem',
                fontWeight: '600',
                color: '#1f2937',
                marginBottom: '1rem',
              }}
            >
              Thank You!
            </h4>
            <p
              style={{
                color: '#6b7280',
                marginBottom: '2rem',
              }}
            >
              Your submission has been received successfully.
            </p>
            <button
              onClick={() => setSubmitted(false)}
              style={{
                background: '#184778',
                border: 'none',
                borderRadius: '6px',
                padding: '12px 24px',
                color: 'white',
                fontSize: '0.875rem',
                fontWeight: '500',
                cursor: 'pointer',
              }}
            >
              Submit Another Response
            </button>
          </div>
        </div>
      )
    }

    return (
      <div
        style={{
          minHeight: '100vh',
          background: '#f9fafb',
          padding: '24px 15px ',
        }}
      >
        <ToastMessage />
        <div style={{}}>
          {/* <div
            style={{
              background: "white",
              borderRadius: "12px",
              padding: "2rem",
              marginBottom: "2rem",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              border: "1px solid #e5e7eb",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <h1
                  style={{
                    fontSize: "2rem",
                    fontWeight: "700",
                    marginBottom: "0.5rem",
                    color: "#1f2937",
                  }}
                >
                  Form Builder
                </h1>
                <nav aria-label="breadcrumb">
                  <ol
                    style={{
                      display: "flex",
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      fontSize: "0.875rem",
                      color: "#6b7280",
                    }}
                  >
                    <li className="breadcrumb-item" onClick={() => setCurrentView("list")} style={{ cursor: "pointer" }}>
                      Dynamic Forms
                    </li>
                    <li style={{ marginRight: "0.5rem" }}>/</li>
                    <li>Forms Preview</li>
                  </ol>
                </nav>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <button
                  onClick={onBack}
                  style={{
                    background: "#f9fafb",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    color: "#374151",
                    fontSize: "0.875rem",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <FaArrowLeft size={14} />
                  Back to Editor
                </button>
               
              </div>
            </div>
          </div> */}
          <div style={{ marginBottom: '22px' }}>
            <div className="brood_comes_div">
              <div className="row align-items-center">
                <div className="col-md-6 brood_comes_heading">
                  <h2 className="mb-2">
                    <div className="brood_comes_part">
                      {/* <FaCheck /> */}
                      <i class="fa fa-table"></i>
                    </div>
                    Dynamic Forms
                  </h2>
                  <nav aria-label="breadcrumb ">
                    <ol
                      style={{
                        display: 'flex',
                        listStyle: 'none',
                        padding: 0,
                        margin: 0,
                        fontSize: '0.875rem',
                        color: '#6b7280',
                      }}
                    >
                      <li
                        className="breadcrumb-item link_brood_comes"
                        onClick={() => setCurrentView('list')}
                        style={{ cursor: 'pointer' }}
                      >
                        Dynamic Forms
                      </li>
                      <li style={{ marginInline: '0.5rem' }}> / </li>
                      <li>Forms Preview</li>
                    </ol>
                  </nav>
                </div>
                <div className="col-md-6 text-end">
                  <button onClick={onBack} className="btn btn-outline-primary ">
                    <FaArrowLeft />
                    Back to Editor
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              borderRadius: '12px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            }}
          >
            <div style={{ padding: '0rem' }}>
              <FormPreview
                title={currentForm.form_title}
                description={currentForm.form_description}
                fields={currentForm.fields || []}
                onSubmit={handleSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Styles
  const tableHeaderStyle = {
    padding: '1rem 1.5rem',
    fontSize: '16px',
    fontWeight: '600',
    color: '#6b7280',
    letterSpacing: '0.05em',
    borderBottom: '1px solid #e5e7eb',
  }

  const tableCellStyle = {
    padding: '1rem 1.5rem',
    fontSize: '0.875rem',
    verticalAlign: 'middle',
  }
  // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false)
  const fetchPermission = async () => {
    setCheckUserLoading(true)
    try {
      const hasPermission = await checkPermission('Dynamic Forms', 'view')
      if (!hasPermission) return
    } catch (error) {
      console.error('Error Check Permission:', error)
    } finally {
      setCheckUserLoading(false)
    }
  }
  useEffect(() => {
    fetchPermission()
  }, [])
  // Main render method
  return (
    <div
      style={{
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      {currentView === 'list' && renderFormsList()}
      {currentView === 'create' && (
        <FormCreator
          formId={currentFormId}
          forms={forms}
          onSave={handleFormSave}
          onCancel={() => {
            setTimeout(() => {
              setCurrentView('list')
              setIsEditMode(false)
              setCurrentFormId(null)
            }, 2000) //delayed for 2 seconds to allow success pop up to show.
          }}
          onGoback={() => setCurrentView('list')}
          onPreview={() => setCurrentView('preview')}
          updateForm={updateForm}
          isEditMode={isEditMode}
          formTypes={FormTypes}
          selectedFormType={selectedFormType}
          setSelectedFormType={setSelectedFormType}
        />
      )}
      {currentView === 'preview' && (
        <FormPreviewPage
          formId={currentFormId}
          forms={forms}
          onBack={() => setCurrentView('create')}
          updateForm={updateForm}
        />
      )}
    </div>
  )
};

export default FormsDashboard;
